/* eslint-disable camelcase */
jQuery(document).ready(function ($) {
	const $preloader = document.querySelector('.preloader');
	let isInitializing = true;

	if (document.referrer) {
		sessionStorage.setItem('previousPage', document.referrer);

		$(window).on('popstate', function () {
			const previousPage = sessionStorage.getItem('previousPage');
			if (previousPage) {
				window.location.href = previousPage;
			}
		});
	}

	initFilters();

	setTimeout(function () {
		isInitializing = false;
	}, 1000);

	function initFilters() {
		const $filterSelects = $('.filter-select');
		const $filtersTop = $('.filters__top');
		const $filtersBox = $('.filters__top-filters');
		const $triggerTablet = $('.filters__top-opener');

		if (!$filterSelects.length) {
			return;
		}

		$(document).off('.filters');
		$triggerTablet.off('.filters');
		$filterSelects.find('.filter-select__trigger').off('.filters');
		$filterSelects.find('input[type="checkbox"]').off('.filters');

		if (
			window.innerWidth < 1025 &&
			$triggerTablet.length &&
			$filtersBox.length
		) {
			$triggerTablet.on('click.filters', function (e) {
				e.stopPropagation();
				$filtersTop.toggleClass('active');
				$filtersBox.stop(true, true).slideToggle(300);
			});

			$(document).on('click.filters', function (e) {
				if (
					!$filtersTop.is(e.target) &&
					$filtersTop.has(e.target).length === 0
				) {
					$filtersTop.removeClass('active');
					$filtersBox.stop(true, true).slideUp(300);
				}
			});
		}

		$filterSelects.each(function () {
			const $selectBox = $(this);

			const $trigger = $selectBox.find('.filter-select__trigger');
			const $options = $selectBox.find('.filter-select__options');
			const $checkboxes = $options.find('input[type="checkbox"]');
			const $realSelect = $selectBox.find('select.real-select');

			if (
				!$trigger.length ||
				!$options.length ||
				!$checkboxes.length ||
				!$realSelect.length
			) {
				return;
			}

			setupTrigger($selectBox, $trigger, $options);
			setupOutsideClickHandler($selectBox, $options);
			setupCheckboxChangeHandler($checkboxes, $realSelect);
		});

		setupResetFiltersHandler();
		setupCardCategoryButtons();

		const urlParams = new URLSearchParams(window.location.search);
		const filters = urlParams.get('filters');
		if (filters) {
			applyFiltersFromUrl();
		} else {
			updateChoises();
		}
	}

	function setupTrigger($selectBox, $trigger, $options) {
		$trigger.on('click', function (e) {
			e.stopPropagation();

			if (!$selectBox.length || !$options.length) {
				return;
			}

			if ($selectBox.hasClass('active')) {
				closeFilter($selectBox, $options);
			} else {
				closeAllFilters();
				openFilter($selectBox, $options);
			}
		});
	}

	function setupOutsideClickHandler($selectBox, $options) {
		$(document).on('click', function (e) {
			if (!$selectBox.length || !$options.length) {
				return;
			}

			if (
				!$selectBox.is(e.target) &&
				$selectBox.has(e.target).length === 0
			) {
				closeFilter($selectBox, $options);
			}
		});
	}

	function setupCheckboxChangeHandler($checkboxes, $realSelect) {
		$checkboxes.on('change', function () {
			if (isInitializing) {
				return;
			}

			if (!$checkboxes.length || !$realSelect.length) {
				return;
			}

			const $this = $(this);
			const isClear = $this.val() === 'clear';

			if (isClear) {
				$checkboxes.prop('checked', false);
				$realSelect.find('option').prop('selected', false);
				$this.prop('checked', false);
			} else {
				$checkboxes.filter('[value="clear"]').prop('checked', false);
			}

			syncRealSelect($checkboxes, $realSelect);
			updateChoises();
			updateUrlParams();
		});
	}

	function setupCardCategoryButtons() {
		$('.webinar-filter-card__category')
			.off('click')
			.on('click', function () {
				const slug = $(this).data('slug');

				if (!slug) {
					return;
				}

				const $checkbox = $(
					`.filter-select__option input[type="checkbox"][value="${slug}"]`
				);

				if ($checkbox.length && !$checkbox.prop('checked')) {
					$checkbox.prop('checked', true).trigger('change');
				}
			});
	}

	function updateUrlParams() {
		if (isInitializing) {
			return;
		}

		const selectedTerms = getAllCheckedTerms();
		const urlParams = new URLSearchParams(window.location.search);

		if (selectedTerms.length > 0) {
			urlParams.set('filters', selectedTerms.join(','));
		} else {
			urlParams.delete('filters');
		}

		urlParams.delete('paged');
		urlParams.delete('page');

		let cleanPathname = window.location.pathname.replace(
			/\/page\/\d+\/?$/,
			''
		);
		if (cleanPathname && !cleanPathname.endsWith('/')) {
			cleanPathname = cleanPathname + '/';
		}
		if (!cleanPathname || cleanPathname === '/') {
			cleanPathname = '/webinars/';
		}

		const urlString = '?' + urlParams.toString();
		const finalUrl =
			urlString === '?' ? cleanPathname : cleanPathname + urlString;

		history.pushState(null, '', finalUrl);
		performAjaxFilterRequest(1);
	}

	function updateChoises() {
		const $choisesContainer = $('.filters__choises');
		$choisesContainer.empty();

		$('.filter-select__option input[type="checkbox"]:checked').each(
			function () {
				const $checkbox = $(this);
				const value = $checkbox.val();
				if (value === 'clear') {
					return;
				}

				const text = $checkbox
					.closest('label')
					.find('.filter-select__text')
					.text()
					.trim();

				const $button = $(`
				<button class="filter-choice-btn button-rem button-rem-filter" data-value="${value}">
					${text} <span class="remove">&times;</span>
				</button>
			`);

				$choisesContainer.append($button);
			}
		);
	}

	function getAllCheckedTerms() {
		const terms = [];
		$(
			'.filters__top-filters .filter-select__option input[type="checkbox"]:checked'
		).each(function () {
			const $checkbox = $(this);
			const value = $checkbox.val();
			if (value !== 'clear') {
				terms.push(value);
			}
		});
		return terms;
	}

	function applyFiltersFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);
		const filters = urlParams.get('filters');

		if (filters) {
			const terms = filters.split(',');

			$('.filter-select__option input[type="checkbox"]').each(
				function () {
					const $checkbox = $(this);
					if (terms.includes($checkbox.val())) {
						$checkbox[0].checked = true;
					}
				}
			);

			$('.filter-select').each(function () {
				const $selectBox = $(this);
				const $checkboxes = $selectBox.find(
					'.filter-select__option input[type="checkbox"]'
				);
				const $realSelect = $selectBox.find('select.real-select');
				if ($checkboxes.length && $realSelect.length) {
					syncRealSelect($checkboxes, $realSelect);
				}
			});

			updateChoises();
		} else {
			updateChoises();
		}
	}

	function performAjaxFilterRequest(page = 1) {
		if (isInitializing) {
			return;
		}

		if (
			typeof ajax_object === 'undefined' ||
			!ajax_object ||
			!ajax_object.ajax_url
		) {
			return;
		}

		const selectedTerms = getAllCheckedTerms();

		$.ajax({
			url: ajax_object.ajax_url,
			type: 'GET',
			data: {
				action: 'filter_webinars',
				page,
				terms: selectedTerms,
			},
			beforeSend() {
				if ($preloader) {
					$preloader.classList.add('animate');
				}
			},
			success(response) {
				if (response.success) {
					$('.filters__content-inner').html(response.data);
					if ($preloader) {
						$preloader.classList.remove('animate');
					}
					setupCardCategoryButtons();
					setCurrentPagination(page);
				} else {
					$('.filters__content-inner').html(
						'<p>Webinars not found</p>'
					);
				}
			},
			error() {
				if ($preloader) {
					$preloader.classList.remove('animate');
				}
				if (!isInitializing) {
					$('.filters__content-inner').html('<p>Error request</p>');
				}
			},
		});
	}

	function syncRealSelect($checkboxes, $realSelect) {
		if (!$checkboxes.length || !$realSelect.length) {
			return;
		}

		const selectedValues = $checkboxes
			.filter(':checked')
			.map(function () {
				return this.value;
			})
			.get();

		$realSelect.find('option').each(function () {
			$(this).prop('selected', selectedValues.includes(this.value));
		});

		if (!isInitializing) {
			$realSelect.trigger('change');
		}
	}

	function setupResetFiltersHandler() {
		$(document).on('click', '.reset-filters', function () {
			$('.filter-select__option input[type="checkbox"]').prop(
				'checked',
				false
			);
			updateChoises();
			updateUrlParams();
		});
	}

	function openFilter($selectBox, $options) {
		if (
			window.innerWidth < 1025 ||
			!$selectBox.length ||
			!$options.length
		) {
			return;
		}
		$selectBox.addClass('active');
		$options.stop(true, true).slideDown(400);
	}

	function closeFilter($selectBox, $options) {
		if (
			window.innerWidth < 1025 ||
			!$selectBox.length ||
			!$options.length
		) {
			return;
		}
		$selectBox.removeClass('active');
		$options.stop(true, true).slideUp(400);
	}

	function closeAllFilters() {
		$('.filter-select')
			.removeClass('active')
			.find('.filter-select__options')
			.stop(true, true)
			.slideUp(400);
	}

	function setCurrentPagination(page) {
		$('.pagination__page').removeClass('current');
		$('.pagination__page').each(function () {
			if ($(this).text().trim() === page.toString()) {
				$(this).addClass('current');
			}
		});
	}

	$(document).on('click', '.filter-choice-btn', function () {
		const valueToRemove = $(this).data('value');

		$(
			`.filter-select__option input[type="checkbox"][value="${valueToRemove}"]`
		)
			.prop('checked', false)
			.trigger('change');

		$(this).remove();
	});

	$(document).on(
		'change',
		'.filters__top-filters .filter-select__option input[type="checkbox"]',
		function () {
			if (isInitializing) {
				return;
			}
			performAjaxFilterRequest();
		}
	);

	$(document).on('click', '.pagination__page', function (e) {
		if ($(this).hasClass('disabled')) {
			return;
		}

		if ($(this).find('.pagination__elipsis').length > 0) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const $pageDiv = $(this);
		const $link = $pageDiv.find('a');

		if (!$link.length) {
			return;
		}

		let href = $link.attr('href');

		if (!href) {
			const page = $pageDiv.data('paged') || 1;
			if (page > 0) {
				const basePath = window.location.pathname.replace(
					/\/page\/\d+\/?$/,
					''
				);
				href =
					page === 1
						? basePath
						: basePath.replace(/\/$/, '') + '/page/' + page + '/';
				if (window.location.search) {
					href += window.location.search;
				}
			} else {
				return;
			}
		}

		if (href.startsWith('/')) {
			href = window.location.origin + href;
		} else if (
			!href.startsWith('http://') &&
			!href.startsWith('https://')
		) {
			const currentPath = window.location.pathname
				.replace(/\/page\/\d+\/?$/, '')
				.replace(/\/$/, '');
			href = window.location.origin + currentPath + '/' + href;
		}

		const url = new URL(href, window.location.origin);
		let page = 1;

		if (url.searchParams.has('paged')) {
			page = parseInt(url.searchParams.get('paged'), 10) || 1;
		} else if (url.searchParams.has('page')) {
			page = parseInt(url.searchParams.get('page'), 10) || 1;
		} else {
			const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);
			if (pathMatch) {
				page = parseInt(pathMatch[1], 10) || 1;
			} else {
				page = $pageDiv.data('paged') || 1;
			}
		}

		const newUrl =
			url.pathname + (url.search ? url.search : '') + (url.hash || '');
		history.pushState(null, '', newUrl);

		performAjaxFilterRequest(page);

		setTimeout(() => {
			if ($('.filters').length > 0) {
				$('html, body').animate(
					{
						scrollTop:
							$('.filters').offset().top - $('header').height(),
					},
					500
				);
			}
		}, 500);
	});

	$(window).on('orientationchange', function () {
		location.reload();
	});
});
